<mat-form-field appearance="fill">
	<mat-label>{{ 'EXTERNALREGISTRATIONFORM.COUNTRY.PLACEHOLDER' | translate | uppercase }}</mat-label>
	<mat-select [(ngModel)]="member.country">
		<mat-option *ngFor="let country of countries" [value]="country.alpha2">
			{{ country.name }}
		</mat-option>
	</mat-select>
</mat-form-field>
